module.exports = "/images/nz.svg?3b065016b209a1dc85210d3907fa78aa";